<div
    class="cmps-cdk-d-flex cmps-cdk-border-width-1p cmps-cdk-border-solid cmps-cdk-border-color-grey-300 cmps-cdk-border-radius-4p cmps-cdk-overflow-hidden cmps-cdk-bg-color-white"
>
    <div>
        <button
            cmpsIconButton
            [cmpsTooltipTrigger]="'Expand All Sections'"
            (click)="evalRef.collapsed = false"
        >
            <cmps-icon
                class="cmps-cdk-bg-color-transparent cmps-cdk-fill-grey-400 hover:cmps-cdk-fill-blue-100"
                svgIcon="expand-all-outline"
            ></cmps-icon>
        </button>
    </div>
    <div
        class="cmps-cdk-border-l-width-1px cmps-cdk-border-l-solid cmps-cdk-border-l-color-grey-300"
    >
        <button
            cmpsIconButton
            [cmpsTooltipTrigger]="'Collapse All Sections'"
            (click)="evalRef.collapsed = true"
        >
            <cmps-icon
                class="cmps-cdk-bg-color-transparent cmps-cdk-fill-grey-400 hover:cmps-cdk-fill-blue-100"
                svgIcon="collapse-all-outline"
            ></cmps-icon>
        </button>
    </div>
</div>
